export default "__VITE_ASSET__BbwMItI0__"